var map = {
	"./": 72812,
	"./App": 54111,
	"./App.css": 44050,
	"./App.js": 54111,
	"./Joker": 41583,
	"./Joker.js": 41583,
	"./SaveFileViewer": 78023,
	"./SaveFileViewer.js": 78023,
	"./balatro.ttf": 68771,
	"./index": 72812,
	"./index.css": 59555,
	"./index.js": 72812,
	"./jokerInfo": 76539,
	"./jokerInfo.js": 76539,
	"./jokers/j_8_ball.png": 28332,
	"./jokers/j_abstract.png": 8642,
	"./jokers/j_acrobat.png": 83224,
	"./jokers/j_ancient.png": 43254,
	"./jokers/j_arrowhead.png": 15715,
	"./jokers/j_astronomer.png": 58428,
	"./jokers/j_banner.png": 4102,
	"./jokers/j_baron.png": 56842,
	"./jokers/j_baseball.png": 53932,
	"./jokers/j_blackboard.png": 61727,
	"./jokers/j_bloodstone.png": 19399,
	"./jokers/j_blue_joker.png": 68688,
	"./jokers/j_blueprint.png": 96171,
	"./jokers/j_bootstraps.png": 40689,
	"./jokers/j_brainstorm.png": 32207,
	"./jokers/j_bull.png": 37419,
	"./jokers/j_burglar.png": 14357,
	"./jokers/j_burnt.png": 29967,
	"./jokers/j_business.png": 83202,
	"./jokers/j_caino.png": 13414,
	"./jokers/j_campfire.png": 15291,
	"./jokers/j_card_sharp.png": 97983,
	"./jokers/j_cartomancer.png": 83241,
	"./jokers/j_castle.png": 63176,
	"./jokers/j_cavendish.png": 92501,
	"./jokers/j_ceremonial.png": 43087,
	"./jokers/j_certificate.png": 59995,
	"./jokers/j_chaos.png": 7582,
	"./jokers/j_chicot.png": 80384,
	"./jokers/j_clever.png": 15277,
	"./jokers/j_cloud_9.png": 59345,
	"./jokers/j_constellation.png": 32403,
	"./jokers/j_crafty.png": 38483,
	"./jokers/j_crazy.png": 78177,
	"./jokers/j_credit_card.png": 98850,
	"./jokers/j_delayed_grat.png": 85765,
	"./jokers/j_devious.png": 68095,
	"./jokers/j_diet_cola.png": 26208,
	"./jokers/j_dna.png": 11117,
	"./jokers/j_drivers_license.png": 3387,
	"./jokers/j_droll.png": 23167,
	"./jokers/j_drunkard.png": 24997,
	"./jokers/j_duo.png": 44902,
	"./jokers/j_dusk.png": 16851,
	"./jokers/j_egg.png": 28825,
	"./jokers/j_erosion.png": 82105,
	"./jokers/j_even_steven.png": 28136,
	"./jokers/j_faceless.png": 48700,
	"./jokers/j_family.png": 88760,
	"./jokers/j_fibonacci.png": 74706,
	"./jokers/j_flash.png": 33592,
	"./jokers/j_flower_pot.png": 7725,
	"./jokers/j_fortune_teller.png": 11310,
	"./jokers/j_four_fingers.png": 53399,
	"./jokers/j_gift.png": 81670,
	"./jokers/j_glass.png": 73042,
	"./jokers/j_gluttenous_joker.png": 54930,
	"./jokers/j_golden.png": 65167,
	"./jokers/j_greedy_joker.png": 83388,
	"./jokers/j_green_joker.png": 25507,
	"./jokers/j_gros_michel.png": 67730,
	"./jokers/j_hack.png": 39907,
	"./jokers/j_half.png": 13199,
	"./jokers/j_hallucination.png": 31977,
	"./jokers/j_hanging_chad.png": 26113,
	"./jokers/j_hiker.png": 3099,
	"./jokers/j_hit_the_road.png": 99804,
	"./jokers/j_hologram.gif": 69882,
	"./jokers/j_ice_cream.png": 70844,
	"./jokers/j_idol.png": 79802,
	"./jokers/j_invisible.png": 84451,
	"./jokers/j_joker.png": 57471,
	"./jokers/j_jolly.png": 31700,
	"./jokers/j_juggler.png": 28488,
	"./jokers/j_loyalty_card.png": 59403,
	"./jokers/j_luchador.png": 19728,
	"./jokers/j_lucky_cat.png": 37139,
	"./jokers/j_lusty_joker.png": 87643,
	"./jokers/j_mad.png": 25948,
	"./jokers/j_madness.png": 20605,
	"./jokers/j_mail.png": 23505,
	"./jokers/j_marble.png": 31411,
	"./jokers/j_matador.png": 65564,
	"./jokers/j_merry_andy.png": 93610,
	"./jokers/j_midas_mask.png": 71689,
	"./jokers/j_mime.png": 99532,
	"./jokers/j_misprint.png": 67742,
	"./jokers/j_mr._bones.png": 31967,
	"./jokers/j_mystic_summit.png": 91489,
	"./jokers/j_obelisk.png": 91189,
	"./jokers/j_odd_todd.png": 38641,
	"./jokers/j_onyx_agate.png": 62945,
	"./jokers/j_oops.png": 57873,
	"./jokers/j_order.png": 8374,
	"./jokers/j_pareidolia.png": 94882,
	"./jokers/j_perkeo.png": 57332,
	"./jokers/j_photograph.png": 86872,
	"./jokers/j_popcorn.png": 1821,
	"./jokers/j_raised_fist.png": 86551,
	"./jokers/j_ramen.png": 33391,
	"./jokers/j_red_card.png": 53546,
	"./jokers/j_reserved_parking.png": 1749,
	"./jokers/j_ride_the_bus.png": 35605,
	"./jokers/j_riff_raff.png": 32795,
	"./jokers/j_ring_master.png": 68837,
	"./jokers/j_rocket.png": 10868,
	"./jokers/j_rough_gem.png": 34485,
	"./jokers/j_runner.png": 24154,
	"./jokers/j_sattelite.png": 97075,
	"./jokers/j_scary_face.png": 14592,
	"./jokers/j_scholar.png": 3808,
	"./jokers/j_seance.png": 87513,
	"./jokers/j_seeing_double.png": 46459,
	"./jokers/j_selzer.png": 62579,
	"./jokers/j_shoot_the_moon.png": 48671,
	"./jokers/j_shortcut.png": 64946,
	"./jokers/j_sixth_sense.png": 15801,
	"./jokers/j_sly.png": 83824,
	"./jokers/j_smeared.png": 69077,
	"./jokers/j_smiley.png": 23725,
	"./jokers/j_sock_and_buskin.png": 9511,
	"./jokers/j_space.png": 23868,
	"./jokers/j_splash.png": 50785,
	"./jokers/j_square.png": 37065,
	"./jokers/j_steel_joker.png": 94043,
	"./jokers/j_stencil.png": 26058,
	"./jokers/j_stone.png": 133,
	"./jokers/j_stuntman.png": 4472,
	"./jokers/j_supernova.png": 55245,
	"./jokers/j_superposition.png": 97454,
	"./jokers/j_swashbuckler.png": 88260,
	"./jokers/j_throwback.png": 95315,
	"./jokers/j_ticket.png": 54004,
	"./jokers/j_to_the_moon.png": 47627,
	"./jokers/j_todo_list.png": 90981,
	"./jokers/j_trading.png": 37077,
	"./jokers/j_tribe.png": 55818,
	"./jokers/j_triboulet.png": 25888,
	"./jokers/j_trio.png": 1266,
	"./jokers/j_troubadour.png": 63491,
	"./jokers/j_trousers.png": 78823,
	"./jokers/j_turtle_bean.png": 5949,
	"./jokers/j_vagabond.png": 37148,
	"./jokers/j_vampire.png": 41716,
	"./jokers/j_walkie_talkie.png": 33770,
	"./jokers/j_wee.png": 84159,
	"./jokers/j_wily.png": 18209,
	"./jokers/j_wrathful_joker.png": 9553,
	"./jokers/j_yorick.png": 37985,
	"./jokers/j_zany.png": 14868,
	"./loading": 10204,
	"./loading.js": 10204,
	"./setupTests": 89472,
	"./setupTests.js": 89472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;